import { routesBuilder } from '@guiker/api-definition'

import { NEWPropertyOwnership } from '../../../entity'
import { transferPropertyOwnershipSchema, upsertRealOwnerSchema } from '../schemas'
import { paths } from './paths'

const basePath = paths.NEWPropertyOwnership.all.withId(':id')
const { buildPut, buildGet, buildPost } = routesBuilder<NEWPropertyOwnership>()({ basePath })

export const routes = {
  updateToRealOwner: buildPut({
    path: '/update-to-real-owner',
    payloadSchema: upsertRealOwnerSchema,
  }),
  readOneNEWPropertyOwnership: buildGet({
    response: null as NEWPropertyOwnership,
  }),
  transferPropertyOwnership: buildPost({
    payloadSchema: transferPropertyOwnershipSchema,
  }),
}
